/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Why a moderator refused a review.
 *
 * The description is the moderator-facing wording, so it goes through the lazy translator —
 * the enum is built at import time, long before a request locale exists.
 */
export type ReviewRejectionReason = typeof ReviewRejectionReason[keyof typeof ReviewRejectionReason];


export const ReviewRejectionReason = {
  spam: 'spam',
  abuse: 'abuse',
  off_topic: 'off_topic',
  privacy: 'privacy',
  fake_review: 'fake_review',
  conflict: 'conflict',
  illegal: 'illegal',
  defamation: 'defamation',
  duplicate: 'duplicate',
  low_quality: 'low_quality',
  manipulation: 'manipulation',
} as const;
